import { useSyncExternalStore } from "react";

//Single source of truth for responsive behavior in JS (MOBILE_PLAN.md §2.2).
//CSS-only adaptations should use plain media queries; use this hook only when
//the component tree itself must differ (e.g. card list vs table).
export function useMediaQuery(query) {
    return useSyncExternalStore(
        (notify) => {
            const mql = window.matchMedia(query);
            mql.addEventListener("change", notify);
            return () => mql.removeEventListener("change", notify);
        },
        () => window.matchMedia(query).matches
    );
}

//Mobile = below Tailwind's md breakpoint. Keep this the one definition of
//"mobile" app-wide so JS and the CSS `@media (max-width: 767px)` blocks agree.
export function useIsMobile() {
    return useMediaQuery("(max-width: 767px)");
}

//True on touch-primary devices regardless of viewport size (tablets too).
export function useIsCoarsePointer() {
    return useMediaQuery("(pointer: coarse)");
}
